import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { E3DataUploadTable } from "./table";
import { E3DataUploadEdit } from "./edit";

export default function E3DataUpload() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Chargement de fichiers");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<E3DataUploadEdit />} />
      <Route index element={<E3DataUploadTable />} />
    </Routes>
  );
}
